module.exports = __webpack_public_path__ + "static/media/report_4.f39a6759.jpg";